import { CommonModule } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';

@Component({
  selector: 'app-chips-toggle',
  templateUrl: './chips-toggle.component.html',
  styleUrl: './chips-toggle.component.css',
  standalone: true,
  imports: [CommonModule],
})
export class ChipsToggleComponent<T> {
  options = input.required<{ label: string; value: T }[]>();

  // Use null to represent 'All'
  value = input<T | null>(null);
  selectionChange = output<T | null>();
  moreCategoriesClick = output<void>();

  // Show "More Categories" button when there are more than 10 options
  showMoreButton = input<boolean>(false);

  viewAll = computed(() => this.value() === null);
  moreCategoriesSelected = signal<boolean>(false);

  onItemSelected(value: T | null) {
    this.moreCategoriesSelected.set(false);
    this.selectionChange.emit(value);
  }

  onMoreCategoriesClick() {
    this.moreCategoriesSelected.set(true);
    this.moreCategoriesClick.emit();
  }

  resetMoreCategories() {
    this.moreCategoriesSelected.set(false);
  }
}
